export default "__VITE_ASSET__BuVHJ6tQ__"